var _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9377 21.575V24.1125C13.9377 26.2625 11.9376 28 9.47514 28C7.01264 28 5.00012 26.2625 5.00012 24.1125V21.575C5.00012 23.725 7.00014 25.25 9.47514 25.25C11.9376 25.25 13.9377 23.7125 13.9377 21.575Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9373 18.1375C13.9373 18.7625 13.7623 19.3375 13.4623 19.8375C12.7248 21.05 11.2122 21.8125 9.46225 21.8125C7.71225 21.8125 6.19973 21.0375 5.46223 19.8375C5.16223 19.3375 4.9873 18.7625 4.9873 18.1375C4.9873 17.0625 5.48728 16.1 6.28728 15.4C7.09978 14.6875 8.21224 14.2625 9.44974 14.2625C10.6872 14.2625 11.7998 14.7 12.6123 15.4C13.4373 16.0875 13.9373 17.0625 13.9373 18.1375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9377 18.1375V21.575C13.9377 23.725 11.9376 25.25 9.47514 25.25C7.01264 25.25 5.00012 23.7125 5.00012 21.575V18.1375C5.00012 15.9875 7.00014 14.25 9.47514 14.25C10.7126 14.25 11.8252 14.6875 12.6377 15.3875C13.4377 16.0875 13.9377 17.0625 13.9377 18.1375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14.2124V16.7875C28 17.475 27.45 18.0375 26.75 18.0625H24.3C22.95 18.0625 21.7125 17.075 21.6 15.725C21.525 14.9375 21.825 14.2 22.35 13.6875C22.8125 13.2125 23.45 12.9375 24.15 12.9375H26.75C27.45 12.9625 28 13.5249 28 14.2124Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.625V11.125C3 7.725 5.05 5.35 8.2375 4.95C8.5625 4.9 8.9 4.875 9.25 4.875H20.5C20.825 4.875 21.1375 4.88748 21.4375 4.93748C24.6625 5.31248 26.75 7.7 26.75 11.125V12.9375H24.15C23.45 12.9375 22.8125 13.2125 22.35 13.6875C21.825 14.2 21.525 14.9375 21.6 15.725C21.7125 17.075 22.95 18.0625 24.3 18.0625H26.75V19.875C26.75 23.625 24.25 26.125 20.5 26.125H17.375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMoney);
export default __webpack_public_path__ + "static/media/wallet-money.498b85de87772ba5bf18038e58efdf80.svg";
export { ForwardRef as ReactComponent };